/** Espelha `NotificationSourceType` do backend: o registro que o clique na notificação abre. */
export enum NotificationSourceType {
  SALES_ORDER = 'SALES_ORDER',
  PICKLIST = 'PICKLIST',
  WAREHOUSE_TASK = 'WAREHOUSE_TASK',
  POINT_OF_SALE = 'POINT_OF_SALE',
  TERMINAL = 'TERMINAL',
  CLIENT_FEEDBACK = 'CLIENT_FEEDBACK',
  NFCE = 'NFCE',
  NFE_OUT = 'NFE_OUT',
  NFE_IN = 'NFE_IN',
  NFE_DISTRIBUTION_DOCUMENT = 'NFE_DISTRIBUTION_DOCUMENT',
  NFCE_DISABLE = 'NFCE_DISABLE',
  CERTIFICATE = 'CERTIFICATE',
  BUY_ORDER = 'BUY_ORDER',
  GOODS_RECEIPT = 'GOODS_RECEIPT',
  BILL_TO_PAY = 'BILL_TO_PAY',
  COMMUNITY_SETTLEMENT = 'COMMUNITY_SETTLEMENT',
  PRODUCT = 'PRODUCT',
  PRODUCT_STOCK = 'PRODUCT_STOCK',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  AUTOMATIC_REPLENISHMENT = 'AUTOMATIC_REPLENISHMENT',
  AUTOMATIC_PICKLIST = 'AUTOMATIC_PICKLIST',
}
